import React from 'react';

const Breadcrumb = ({ orderId }) => {
  const breadcrumbItems = [
    { label: 'Home', active: true },
    { label: 'Profile', active: true },
    { label: 'Orders', active: true },
    { label: orderId || '#ORD57986418741', active: false }
  ];

  return (
    <nav
      className="flex flex-col justify-center items-start px-4 py-2.5 w-full text-base text-center bg-white rounded-xl shadow-2xl max-md:max-w-full"
      aria-label="Breadcrumb navigation"
    >
      <ol className="flex gap-1.5 justify-center items-center">
        {breadcrumbItems.map((item, index) => (
          <li key={index} className="flex gap-1.5 items-center">
            <div className="flex gap-2.5 items-start self-stretch my-auto">
              <span className={item.active ? "text-green-500" : "text-zinc-500"}>
                {item.label}
              </span>
            </div>
            {index < breadcrumbItems.length - 1 && (
              <img
                src="https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/cf5f343d5bcfb3f5d00286352d28416bbcf9068d?placeholderIfAbsent=true"
                alt=""
                className="object-contain shrink-0 self-stretch my-auto aspect-square w-[18px]"
                aria-hidden="true"
              />
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
